import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import { useAppContext } from "../context/AppContext";
import {
  onWorkflowSessionExpired,
  resetWorkflowSession,
} from "../utils/workflowSession";

/** Encerra a sessão e volta ao login quando a renovação do token é recusada. */
const SessionWatcher = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { setUsername, setPassword, setGlobalToken } = useAppContext();

  useEffect(
    () =>
      onWorkflowSessionExpired(({ message }) => {
        setUsername("");
        setPassword("");
        setGlobalToken("");
        localStorage.removeItem("portal_username");
        localStorage.removeItem("portal_password");
        localStorage.removeItem("portal_token_payload");
        localStorage.removeItem("portal_refresh_token");
        sessionStorage.clear();

        toast({
          id: "sessao-expirada",
          title: "Sessão encerrada",
          description: message,
          status: "warning",
          duration: 8000,
          isClosable: true,
        });

        resetWorkflowSession();
        navigate("/", { replace: true });
      }),
    [navigate, toast, setUsername, setPassword, setGlobalToken],
  );

  return null;
};

export default SessionWatcher;
